import { AuthMFSDK } from 'authentification-multifacteur-sdk-js';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AuthMFService {
  private otpToken: string;
  public static readonly AUTH_MF_HEADER = 'X-AuthMF-Token';
  private static readonly ID_CONSOMMATEUR = 'd72596e8-0dde-410f-a7ac-8eeeada0ff76';
  private static readonly ID_TRANSACTION = '63f966ee-842d-47ca-8490-bb0973fef3f2';
  private readonly authMFSDK: AuthMFSDK;

  constructor() {
    this.authMFSDK = new AuthMFSDK(AuthMFService.ID_CONSOMMATEUR);
  }

  public obtenirTokenAuthMf(): Promise<string> {
    return this.authMFSDK.ready().then(() => {
      return this.authMFSDK.getToken(AuthMFService.ID_TRANSACTION).then(
        (token) => {
          return token;
        },
        (err) => Promise.reject(new Error(err)) // wrap en erreur pour sonar mais revoir cette logique douteuse
      );
    });
  }

  getOtpToken(): Promise<string> {
    if (this.otpToken == null) {
      return this.obtenirTokenAuthMf();
    }
    return Promise.resolve(this.otpToken);
  }

  setOtpToken(value: string) {
    this.otpToken = value;
  }
}
